<template>
	<inertia-head title="Thank You" />
	<div v-if="data" class="py-3">
		<div class="text-center">
			<div class="mb-3">
				<i :class="icon()"></i>
			</div>
			<div class="fs-4 fw-semibold">
				Thank You, your payment is {{ txnStatus() }}
			</div>
			<div class="fw-semibold mt-3 text-center">
				<div v-if="data.status=='S'">
					<InertiaLink :href="setPasswordUrl()" class="btn btn-success">Set Password</InertiaLink>
				</div>
				<div v-else>
					{{ footerMessage() }}
				</div>
			</div>
			<div class="text-muted my-3">This is your current active plan</div>
		</div>
		<div class="col-lg-7 m-auto">
			<div class="table-responsive">
				<table class="table table-striped table-borderless table-vcenter fs-sm">
					<tbody>
						<tr>
							<th>Transaction ID:</th>
							<td>{{ data.txnid }}</td>
						</tr>
						<tr>
							<th>Name:</th>
							<td>{{ data.fullname }}</td>
						</tr>
						<tr>
							<th>Email:</th>
							<td>{{ data.email }}</td>
						</tr>
						<tr>
							<th>Subscription:</th>
							<td>{{ data.subscription }}</td>
						</tr>
						<tr>
							<th>Amount:</th>
							<td>&#8369; {{ data.amount_format }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
	<div v-if="!data" class="py-3 text-center">
		<div class="mb-3">
			<i class="fa fa-exclamation-triangle fa-7x text-pulse"></i>
		</div>
		<div class="fs-2 fw-semibold">404</div>
		<div class="text-muted my-3">Transaction not found</div>
	</div>
</template>
<script>
import GuestLayout from '../Layouts/GuestLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: GuestLayout,
	props: {
		data: Object,
	},
	setup(props) {

		if(props.data.status=='S')
		{
			fbq('trackSingle', window.fbpixelid, 'Purchase', {
			  value:props.data.amount,
			  currency: "PHP"
			}
			);


			ttq.identify({
	            email 		: props.data.email,
	            phone_number: props.data.mobile,
	      	})

	      	ttq.track('CompletePayment',{
	          	contents: [
	  			{
		            content_id: props.data.txnid,
		            content_name: props.data.subscription,
		            quantity: 1,
		            price: props.data.amount,
	          	}],
	          	content_type: 'product',
	          	value:props.data.amount,
	          	currency: "PHP",
	      	})
		}

		const icon = () => {
			return {
				S: 'far fa-check-circle fa-7x text-success',
				P: 'far fa-clock fa-7x text-warning',
			}[props.data.status]
		}

		const txnStatus = () => {
			return {
				S: 'successful',
				P: 'pending',
			}[props.data.status]
		}

		const footerMessage = () => {
			return {
				S: 'Your activation link is on its way to your email.',
				P: 'Please check your email for the payment instructions of dragonpay.',
			}[props.data.status]
		}

		const setPasswordUrl = () => {
			// Get the hash from the current URL query parameter
			const urlParams = new URLSearchParams(window.location.search);
			const hash = urlParams.get('hash');

			// If hash exists, pass it to set-password route
			if (hash) {
				return route('set.password', { hash: hash });
			}

			// Otherwise, just go to set-password without hash (for authenticated users)
			return route('set.password');
		}

		return {
			icon,
			txnStatus,
			footerMessage,
			setPasswordUrl,
		}
	},
}
</script>
